import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  // When a NEW service worker takes control of the page, reload once.
  // This is required so the page is fully controlled by the fresh SW
  // (with the fetch handler) — otherwise Chrome won't fire
  // `beforeinstallprompt` and the app cannot be installed.
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    // Guard against infinite reload loops
    if (sessionStorage.getItem('pwa_sw_reloaded') === '1') return;
    refreshing = true;
    sessionStorage.setItem('pwa_sw_reloaded', '1');
    window.location.reload();
  });

  window.addEventListener('load', () => {
    const swUrl = '/speeddate/service-worker.js';
    navigator.serviceWorker.register(swUrl, { scope: '/speeddate/' }).then(registration => {
      console.log('[PWA] Service Worker registered, scope:', registration.scope);

      // If a new SW is waiting (update available), skip waiting so it activates now
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      // If an updated SW is installing, skip waiting as soon as it's ready
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        }
      });
    }).catch(registrationError => {
      console.log('[PWA] SW registration failed: ', registrationError);
    });
  });
}
